import React, { useContext, useMemo } from 'react';

import CarrierOptionsPanel from '../components/panels/CarrierOptionsPanel';
import { AuthContext } from '../contexts/authContext';
import {
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierOptionsPage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const userHasPermission = useUserPermission();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  if (!selectedCarrier) {
    return null;
  }

  if (!userHasPermission(selectedCarrier, 'optionPermission')) {
    return null;
  }

  return (
    <Layout
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      <CarrierOptionsPanel
        carrier={selectedCarrier}
        id="options"
        userRole={authUser?.role}
      />
    </Layout>
  );
};

export default CarrierOptionsPage;
